import styled from '@emotion/styled'

export const SettingsSectionContentWrapper = styled.div`
  width: 100%;
`
